export enum AccountType {
  ADV = 1,
  LEAD = 2,
  USER = 3
}

export enum NotifyType {
  LEAD_NEWS = 1,
  LEAD_EVENTS = 2,
  LEAD_PROMOTIONS = 3
}

export enum NotifyTypeI18n {
  LEAD_NEWS = "email_type_news",
  LEAD_EVENTS = "email_type_event",
  LEAD_PROMOTIONS = "email_type_promotions"
}

export const NotifyTypeValueI18n = {
  1: NotifyTypeI18n.LEAD_NEWS,
  2: NotifyTypeI18n.LEAD_EVENTS,
  3: NotifyTypeI18n.LEAD_PROMOTIONS
};

export interface ISubscribeConf {
  channel: string;
  enable: boolean;
  notify_type: NotifyType;
}

export const CHANNEL_EMAIL = "email";
export const CHANNEL_SMS = "sms";
export const CHANNEL_SITE = "site";

export interface ADV_INFO {
  // 枚举具体含义不关注
  status: number;
  name: string;
  country: string;
  pin_time: any;
  currency: string;
  // 数字字符串，枚举具体含义不关注, 99: BC account has child
  role: string;
  // advid，数字字符串
  id: string;
  // timestamp
  visit_time: number
}

export interface BC_INFO extends ADV_INFO {
  child: ADV_INFO[]
}
